@if (item; as item) {
  <div
    class="soft-card flex flex-row gap-1 rounded center flex-nowrap justify-between"
    [ngClass]="(index || 0) < 1 ? 'mt-2' : 'mt-3'"
  >
    <div class="text-content flex flex-col gap-0.5">
      <p class="text-sm color-light mr-2">{{ item?.artikel?.number }}</p>
      @if (item?.customization && item?.customization?.ARTBEZ1) {
        <p class="text-sm font-semibold mb-0">{{ item?.customization?.ARTBEZ1 }}</p>
        <p class="text-sm color-light mb-0">{{ item?.customization?.ARTBEZ2 }}</p>
      } @else {
        <p class="text-sm font-semibold mb-0">{{ item?.artikel?.name || '' }}</p>
      }
      @if (item?.artikel?.supplierItemNumber) {
        <div class="text-sm color-light">{{ item?.artikel?.supplierItemNumber }}</div>
      }
    </div>
    <div class="right-content mr-2 items-center flex flex-row flex-nowrap">
      <span
        class="text-base font-semibold uppercase text-accent-700 mb-0 mr-2 fluid flex-nowrap"
        >{{ item?.quantity }} {{ item?.einheit?.name }}</span
      >
      @if (removingIndex !== index) {
        <i
          class="fa-regular fa-ellipsis-vertical ml-2 p-1 px-2.5 opacity-75 hover:opacity-100 cursor-pointer rounded-sm"
          (click)="moreTap.emit(item)"
        ></i>
      } @else {
        <div class="flex items-center justify-center text-center w-4 h-4">
          <soft-loading-spinner class="spinner spin"></soft-loading-spinner>
        </div>
      }
    </div>
  </div>
}
